// Inner routes
import { requireUser } from '~/apps/shared/permissions';
import { appRoutes as adminRoutes } from './admin/routes';
import { appRoutes as mobileRoutes } from './mobile/routes';

// Client-side routes
export const appRoutes = [
  {
    name: 'pos',
    path: '/pos',
    forwardTo: 'pos.admin.createSale',
    canActivate: requireUser(),
    children: adminRoutes.concat(mobileRoutes),
  },
];
